export default async takeover => { // 'comp-takeover'
	takeover.addEventListener('click',close);
	takeover.querySelector('.close').addEventListener('click',close);
	[...takeover.querySelectorAll('div')].forEach( innerContent => innerContent.addEventListener('click',event => event.stopImmediatePropagation()));
	
	function close(event){
		event.preventDefault();
		takeover.classList.add('fade-out');
		setTimeout(()=> takeover.remove(),300);
	}
};